import axios from '../../common/utils/interceptor';
import { apiUrls } from '../../constants';
import { AssessmentDetails, LanguageDetail, TaskItem } from '../interfaces';

export const fetchAssessmentDetail = async (taskItem: TaskItem): Promise<AssessmentDetails> => {
  let response: AssessmentDetails = {
    availableLanguages: [],
    activeComponentId: 0,
    projectId: 0,
    packageId: 0,
    displayOptions: [],
    selectedLanguageCode: 'EN_US',
    sittingId: 0,
    defaultPackageLanguage: {
      testId: 0,
      language: {
        default: false,
        description: '',
        id: 0,
        integrationIsoCode: '',
        isoCode: '',
        name: '',
      },
    },
  };

  try {
    const { data } = await axios.get(`${apiUrls.GET_ASSESSMENT_DETAIL}/${taskItem.id}`);
    if (data) {
      data.availableLanguages = data.availableLanguages.map((lang: LanguageDetail) => ({
        testId: lang.testId,
        activeComponentId: lang.activeComponentId,
        ...lang.language,
      }));
      response = data;
    }
  } catch (e) {
    console.error('Fetch assessment languages error: ', e);
  }

  return response;
};
